import React, { useState, useEffect } from "react";
import {
  envelopeDownloadAllFile,
  userEnvelopeSpecificDownloadData
} from "../../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../../utils";
import FileDownload from "js-file-download";
import Axios from "axios";

function DownloadDataDoc(props) {
  const [envelopeName, setEnvelopeName] = useState('');
  const [recipientList, setRecipientList] = useState([]);
  const [envId, setEnvId] = useState(0);
  // Remove global selectAll state and useEffect

  useEffect(() => {
    if (props?.downloadDataList) {
      setEnvelopeName(props?.downloadDataList.envelope_name);
      setRecipientList(props?.downloadDataList.recipient_list);
      setEnvId(props?.downloadDataList?.id)
    }
  }, [props?.downloadDataList]);

  // Add a function to handle select all for documents of a recipient
  const handleRecipientSelectAll = (e, parentIndex) => {
    const checked = e.target.checked;
    let list = [...recipientList];
    list[parentIndex].checked = checked;
    list[parentIndex].documents = list[parentIndex].documents.map(doc => ({ ...doc, checked }));
    setRecipientList(list);
  };

  // Helper to get select all state for a recipient's documents
  const getRecipientSelectAllState = (recipient) => {
    if (!recipient.documents || recipient.documents.length === 0) return false;
    const allChecked = recipient.documents.every(d => d.checked);
    const someChecked = recipient.documents.some(d => d.checked);
    if (allChecked) return true;
    if (someChecked) return 'indeterminate';
    return false;
  };

  const hideDownloadDataDoc = (e) => {
    e.preventDefault();
    props.setDownloadDataList({});
  };

  const handleCheckAllChange = (e, index) => {
    let list = [...recipientList];
    list[index]['checked'] = e.target.checked;
    list[index]['documents'] = list[index]['documents'].map((document) => (
      {
        ...document, checked: e.target.checked
      }));
    setRecipientList(list);
  };

  const handleFileChange = (e, index, idx) => {
    let list = [...recipientList];
    list[index]['documents'][idx]['checked'] = e.target.checked;

    let count = 0;
    for (let i = 0; i < list[index]['documents'].length; i++) {
      let data = list[index]['documents'][i];
      if (data.checked) {
        count++;
      }
    }
    if (list[index]['documents'].length === count) {
      list[index]['checked'] = true;
    } else {
      list[index]['checked'] = false;
    }
    setRecipientList(list);
  };

  const downloadSpecificSingleFile = (e, index, idx) => {
    e.preventDefault();

    let list = [...recipientList];
    let recipientobj = list[index]['documents'][idx];
    let recipientID = list[index]['documents'][idx]["id"];

    const recipientListArray = [];

    for (let i = 0; i < recipientList?.length; i++) {
      const recipient = recipientList[i];
      let obj = {};
      const form_list = [];
      const doc_list = [];
      const sign_doc_list = [];

      const { id, documents } = recipient;

      if (documents.includes(recipientobj)) {
        obj['id'] = parseInt(id);

        var item = documents.find(item => item.id === recipientID);

        if (item.entity_type === 1) {
          doc_list.push(parseInt(item.id));
        } else if (item.entity_type === 2) {
          form_list.push(parseInt(item.id));
        } else if (item.entity_type === 3) {
          sign_doc_list.push(parseInt(item.id));
        }

        obj['doc_ids'] = doc_list;
        obj['form_ids'] = form_list;
        obj['sign_doc_ids'] = sign_doc_list;
      }
      recipientListArray.push(obj);
    }

    const totalRecipient = recipientListArray.filter((obj) => Object.keys(obj).length > 0);

    let obj = {
      envelope_id: parseInt(envId),
      recipients: totalRecipient
    };

    props.setLoading(true);

    userEnvelopeSpecificDownloadData(obj)
      .then(result => {
        Axios.get(result.data.path, {
          responseType: 'blob',
        }).then((res) => {
          props.setLoading(false);
          FileDownload(res.data, result.data.name);
        })
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });

  };

  const downloadSpecificFile = (e) => {
    e.preventDefault();

    const recipientListArray = [];

    for (let i = 0; i < recipientList?.length; i++) {
      const recipient = recipientList[i];
      let obj = {};
      const form_list = [];
      const doc_list = [];
      const sign_doc_list = [];

      const { id, checked, documents } = recipient;

      if (checked) {
        obj['id'] = parseInt(id);
        for (let k = 0; k < documents.length; k++) {
          const document = documents[k];
          const { id, entity_type, checked } = document;


          if (entity_type === 1) {
            if (checked) {
              doc_list.push(parseInt(id));
            }
          } else if (entity_type === 2) {
            if (checked) {
              form_list.push(parseInt(id));
            }
          } else if (entity_type === 3) {
            if (checked) {
              sign_doc_list.push(parseInt(id));
            }
          }
        }
        obj['doc_ids'] = doc_list;
        obj['form_ids'] = form_list;
        obj['sign_doc_ids'] = sign_doc_list;
      } else if (documents.some(obj => obj.checked === true)) {
        obj['id'] = parseInt(id);
        for (let k = 0; k < documents.length; k++) {
          const document = documents[k];
          const { id, entity_type, checked } = document;

          if (entity_type === 1) {
            if (checked) {
              doc_list.push(parseInt(id));
            }
          } else if (entity_type === 2) {
            if (checked) {
              form_list.push(parseInt(id));
            }
          } else if (entity_type === 3) {
            if (checked) {
              sign_doc_list.push(parseInt(id));
            }
          }
        }
        obj['doc_ids'] = doc_list;
        obj['form_ids'] = form_list;
        obj['sign_doc_ids'] = sign_doc_list;
      }
      recipientListArray.push(obj);
    }

    const totalRecipient = recipientListArray.filter((obj) => Object.keys(obj).length > 0);

    let obj = {
      envelope_id: parseInt(envId),
      recipients: totalRecipient
    };

    props.setLoading(true);
    if (totalRecipient.length > 0) {
      userEnvelopeSpecificDownloadData(obj)
        .then(result => {
          Axios.get(result.data.path, {
            responseType: 'blob',
          }).then((res) => {
            props.setLoading(false);
            FileDownload(res.data, result.data.name);
          })
        })
        .catch(err => {
          toast.error(Utils.getErrorMessage(err));
          props.setLoading(false);
        });
    } else {
      toast.error('Please select at least one document');
      props.setLoading(false);
    }
  };

  const downloadAllFile = (e) => {
    e.preventDefault();

    let obj = {
      envelope_id: envId
    };
    props.setLoading(true);

    envelopeDownloadAllFile(obj)
      .then(response => {
        Axios.get(response.data.path, {
          responseType: 'blob',
        }).then((res) => {
          props.setLoading(false);
          FileDownload(res.data, response.data.name);
        }).catch(err => {
          toast.error('Oops...something went wrong. File not found.');
          props.setLoading(false);
        });
      })
      .catch(err => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };


  return (
    <div className="offcanvas offcanvas-end ManageDocument" data-bs-scroll="false" tabIndex="-1"
      data-bs-keyboard="true" data-bs-backdrop="static" id="DownloadDataDoc"
      aria-labelledby="DownloadDataDocLabel">
      <div className="offcanvas-header border-bottom">
        <h5 className="offcanvas-title fw-bold" id="DownloadDataDocLabel">Contract - Download</h5>
        <button type="button" className="bg-transparent border-0" data-bs-dismiss="offcanvas"
          onClick={hideDownloadDataDoc} aria-label="Close">
          <i className="bi bi-x-circle" aria-hidden="true" />
        </button>
      </div>

      <div className="offcanvas-body p-0">
        {/* Header with envelope name and download buttons */}
        <div className="p-4 bg-light border-bottom">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <h5 className="m-0  fw-bold">{envelopeName}</h5>
            <div className="btn-group">
              <button
                className="btn btn-primary px-4"
                type="button"
                onClick={(e) => downloadSpecificFile(e)}
                disabled={!recipientList?.some(r => r.checked || r.documents?.some(d => d.checked))}
              >
                <i className="bi bi-download me-2"></i>
                Download
              </button>
              {/* <button
                                className="btn btn-outline-primary"
                                type="button"
                                onClick={(e) => downloadAllFile(e)}
                            >
                                <i className="bi bi-file-earmark-zip me-1"></i>
                                Download All
                            </button> */}
            </div>
          </div>
          {/* Remove global selectAll checkbox */}
          <p className="text-muted mb-0">
            <small>Select Contracts you want to download</small>
          </p>
        </div>

        {/* Main content with accordions */}
        <div className="p-4">
          {recipientList?.length === 0 ? (
            <div className="text-center p-5">
              <i className="bi bi-folder2-open display-4 text-muted mb-3"></i>
              <p>No contracts available for download</p>
            </div>
          ) : (
            <div className="accordion mb-3" id="downloadDocumentsAccordion">
              {recipientList && recipientList.map((item, parentIndex) => (
                <div className="accordion-item border mb-3 rounded shadow-sm" key={parentIndex}>
                  <h2 className="accordion-header" id={`heading${parentIndex}`}>
                    <button
                      className={`accordion-button ${parentIndex !== 0 ? 'collapsed' : ''}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${parentIndex}`}
                      aria-expanded={parentIndex === 0 ? "true" : "false"}
                      aria-controls={`collapse${parentIndex}`}
                    >
                      <div className="d-flex align-items-center w-100">

                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div>
                            <span className="fw-bold">{item.first_name + ' ' + item.last_name}</span>
                            <span className="ms-2 badge bg-light text-dark border">{item.documents?.length || 0} contracts</span>
                          </div>
                          <span className="text-muted small me-3">{item.email}</span>
                        </div>
                      </div>
                    </button>
                  </h2>
                  <div
                    id={`collapse${parentIndex}`}
                    className={`accordion-collapse collapse ${parentIndex === 0 ? 'show' : ''}`}
                    aria-labelledby={`heading${parentIndex}`}
                    data-bs-parent="#downloadDocumentsAccordion"
                  >
                    <div className="accordion-body bg-light">
                      <div className="download_document mb-2">
                        <div className="form-check me-3">
                          <input
                            className="form-check-input cur-pointer"
                            type="checkbox"
                            id={`recipient-select-all-${parentIndex}`}
                            checked={getRecipientSelectAllState(item) === true}
                            ref={el => {
                              if (el) el.indeterminate = getRecipientSelectAllState(item) === 'indeterminate';
                            }}
                            onChange={e => handleRecipientSelectAll(e, parentIndex)}
                          />
                          <label className="form-check-label ms-2" htmlFor={`recipient-select-all-${parentIndex}`}>
                            Select All Contracts
                          </label>
                        </div>
                      </div>
                      <div className="download_document">
                        {item.documents && item.documents.length > 0 ? (
                          item.documents.map((doc, childIndex) => (
                            <div
                              key={childIndex}
                              className="download_box d-flex justify-content-between align-items-center p-3 my-2 bg-white rounded-3 shadow-sm border"
                            >
                              <div className="d-flex align-items-center">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={doc.checked || false}
                                    onChange={e => handleFileChange(e, parentIndex, childIndex)}
                                  />
                                </div>
                                <div className="ms-3">
                                  <p className="mb-0 fw-medium">{doc.name}</p>
                                  {doc.description && (
                                    <small className="text-muted">{doc.description}</small>
                                  )}
                                </div>
                              </div>
                              <div className="d-flex align-items-center">
                                {doc.expiry_date && (
                                  <span className="badge bg-light text-dark me-3">
                                    <i className="bi bi-calendar me-1"></i>
                                    {doc.expiry_date}
                                  </span>
                                )}
                                <button
                                  className="btn btn-sm btn-primary rounded-circle"
                                  onClick={e => downloadSpecificSingleFile(e, parentIndex, childIndex)}
                                  title="Download document"
                                >
                                  <i className="bi bi-download"></i>
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center py-3 text-muted">
                            <p>No documents available</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DownloadDataDoc;